import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Footer from '../shared/Footer/Footer';
import OtherNav from '../shared/Navbar/Other/OtherNav';
import './ProjectDetail.css'

const ProjectDetails = () => {

    const project = JSON.parse(localStorage.getItem('project'))
    console.log(project);

    const { description, projectImg, projectName, screenshot, features, technologies, link, github
    } = project;



    const [selected, setSelected] = useState(screenshot[0])
    return (
        <div>
            <OtherNav></OtherNav>
            <div className='flex my-5 mx-10'>
                <div className='basis-1/2'>
                    <div>
                        <img src={selected} className="h-72 w-full" alt="img" />

                    </div>
                    <div className='flex my-5 gap-5 w-full'>
                        {
                            screenshot.map(ss => <button onClick={() => setSelected(ss)}> <img className='shadow-lg h-full' src={ss} width="184" alt="img" /></button>)
                        }
                    </div>
                </div>
                <div className='mx-10 basis-1/2'>
                    <h3 className='project-title'>{projectName}</h3>
                    <p className='project-description'>{description}</p>
                    <div>
                        <h3 className='font-bold my-3 text-xl feature-title'>Features</h3>
                        <ul className='marker:text-pink-500 list-outside list-disc ml-6 unorder-list'>
                            {features.map(feature => <li>{feature}</li>)}
                        </ul>
                    </div>
                    <div className='my-3'>
                        <span> <i class="fa-solid fa-display link-icon"></i> <a href={link} className="mr-3">Live link</a> </span>
                        <span><i class="fa-solid fa-code-compare link-icon"></i> <a href={github}>Client code</a></span>
                    </div>

                    <div>
                        <h3 className='technology-title text-xl my-3'>Technologies</h3>

                        <div>
                            {
                                technologies.map(technology => <button className='btn technology-btn border-0 btn-sm m-1'>{technology}</button>)
                            }
                        </div>
                    </div>
                </div>
            </div>
            <Footer></Footer>
        </div>
    );
};

export default ProjectDetails;